/* eslint-disable no-console */

/**
 * Enregistrement du service worker.
 *
 * Ce fichier ne pilote PLUS les mises à jour. Toute la décision appartient au
 * contrôle de version (src/service/appVersionService.js), qui compare
 * version.json au numéro compilé dans le bundle et impose une modale bloquante.
 *
 * Ce qui a été retiré ici le 3 août 2026, et pourquoi :
 *
 *  - `showUpdateNotification()` - une seconde fenêtre de mise à jour, avec un
 *    bouton « Plus tard ». Elle contredisait la règle produit (mise à jour
 *    obligatoire) et se serait superposée à la modale du contrôle de version.
 *    Elle n'a de toute façon jamais pu s'afficher : `updated()` n'est appelé
 *    que si le service worker s'active, ce qu'il ne faisait jamais.
 *
 *  - `forceSWUpdate()` - postMessage SKIP_WAITING puis reload() 300 ms plus
 *    tard. Sans purge des caches, le reload pouvait resservir l'ancien
 *    index.html depuis le cache HTTP.
 *
 *  - `storeUpdateState()` - sérialisait une ServiceWorkerRegistration en JSON
 *    dans localStorage, ce qui ne produit qu'un objet vide, puis la relisait
 *    en croyant récupérer un registration utilisable.
 *
 *  - l'écouteur `controllerchange → window.location.reload()` : il rechargeait
 *    la page dès qu'un nouveau service worker prenait le contrôle, à n'importe
 *    quel moment, y compris en pleine saisie de vente et sans la sauvegarder.
 *    Avec le skipWaiting de vue.config.js (retiré lui aussi), c'est la cause
 *    des pages blanches et des ChunkLoadError constatés sur les caisses.
 *    NE PAS LE REMETTRE : le rechargement ne doit jamais être implicite.
 */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  // BASE_URL (publicPath) et non VUE_APP_URL, qui pointe sur localhost dans le
  // .env de développement : un build lancé sans basculer le .env enregistrerait
  // un service worker introuvable.
  register(`${process.env.BASE_URL || '/'}service-worker.js`, {

    ready() {
      console.log('[SW] Application servie depuis le cache du service worker.')
    },

    registered(registration) {
      console.log('[SW] Service worker enregistré.')

      // Une caisse reste ouverte des journées entières. Sans ce rappel, le
      // navigateur ne revérifierait le service worker qu'à la navigation
      // suivante. Le nouveau SW s'installe alors en arrière-plan et ATTEND :
      // il ne prend pas la main tout seul (ni skipWaiting, ni clientsClaim).
      setInterval(() => {
        registration.update()
      }, 2 * 60 * 60 * 1000)
    },

    cached() {
      console.log('[SW] Application disponible hors ligne.')
    },

    updatefound() {
      console.log('[SW] Téléchargement d’une nouvelle version en arrière-plan.')
    },

    updated() {
      // Aucune interface ici : c'est le contrôle de version qui décide, en
      // comparant version.json au bundle exécuté. Simple trace.
      console.log('[SW] Nouvelle version installée, en attente d’activation.')
    },

    offline() {
      console.log('[SW] Aucune connexion - mode hors ligne.')
    },

    error(error) {
      // Un échec d'enregistrement est le symptôme d'un précache invalide
      // (une seule entrée en 404 suffit). À surveiller de près.
      console.error('[SW] Échec de l’enregistrement du service worker :', error)
    }
  })
}
